import ProtectedRoute from "@/components/protected-route/ProtectedRoute";
import { UserInfoProvider } from "@/context/UserInfoContext";
import { Outlet } from "react-router-dom";
import { ModalProvider } from "../game-customisation-template-pages/UnsavedChangesContext";

export const FullScreenLayout = () => (
  <>
    <ModalProvider>
      <ProtectedRoute>
        <UserInfoProvider>
          <Outlet />
        </UserInfoProvider>
      </ProtectedRoute>
    </ModalProvider>
  </>
);
